import { Search } from "lucide-react";
import useFilterOptionManager from "../../../CustomHooks/useFilterOptionManager";

const FilterSearchDropdown = ({
  open,
  category,
  optionList,
  valueAddress,
  setSelectedItems,
  unsort,
}) => {
  const { handleSearch, handleCheckbox, searchList } = useFilterOptionManager({
    category,
    optionList,
    valueAddress,
    setSelectedItems,
    unsort,
  });

  return (
    <div
      className={`filterSearchDropdownWrap ${
        open === 1 ? "grid opacity-1" : "invisible opacity-0"
      }`}
    >
      {optionList.length > 5 && (
        <p className="mx-2 mb-2">
          <input
            type="text"
            placeholder="Search"
            onChange={handleSearch}
            className="filterSearchDropdownInput"
          />
          <Search className="absolute right-3 top-3 w-4" />
        </p>
      )}

      {searchList && searchList.length > 0 ? (
        <ul
          className={`${searchList.length > 6 ? "h-56 overflow-y-scroll" : ""}`}
        >
          {searchList.map((item) => {
            return item.label != null && item.label !== undefined ? (
              <li
                key={`${item.value} + ${item.label}`}
                className={`filterDropdown-item`}
              >
                <input
                  type="checkbox"
                  id={`${item.value}_${item.label}_${category}`}
                  name={item.label}
                  value={item.value.toString().toLowerCase()}
                  className="cursor-pointer accent-dark-blue"
                  onChange={handleCheckbox}
                />
                <label
                  htmlFor={`${item?.value}_${item?.label}_${category}`}
                  className={`filterCheckInputLabel ${
                    item.color ? `${item.color}` : ""
                  }`}
                >
                  {item.label}
                </label>
              </li>
            ) : (
              ""
            );
          })}
        </ul>
      ) : (
        <p className="filterSearchErr">Not Found</p>
      )}
    </div>
  );
};
export default FilterSearchDropdown;
